'use strict';
require('../../../modules/es.array.reverse');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'reverse');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/reverse.js
// module id = 563
// module chunks = 13